import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {}
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }, payload) {
            const response = await http.get('wideband/products', {params: Object.assign(rootState.route.query, payload)});

            commit('setItems', response.data);

            return response;
        },
        async updateBandwidth({ commit }, payload) {
            const response = await http.patch(`wideband/products/${payload.id}/bandwidth`, payload);

            return response;
        },
        async ntdReset({ state }) {
            const response = await http.post(`wideband/products/${state.selected.id}/ntdreset`);

            return response;
        },
        async loopback({ state }) {
            const response = await http.post(`wideband/products/${state.selected.id}/loopback`);

            return response;
        },
        async ntdStatus({ state }) {
            const response = await http.get(`wideband/products/${state.selected.id}/ntdstatus`);

            return response;
        },
        async submitTroubleTicket({ state }, payload) {
            const response = await http.post(`wideband/products/${state.selected.id}/troubleticket`, payload);

            return response;
        },
        async disconnect({ state }) {
            const response = await http.post(`wideband/products/${state.selected.id}/disconnect`);

            return response;
        },
        async sync({ commit }, type) {
            const response = await http.get('wideband/products/sync', {
                params: {type}
            });

            commit('setItems', response.data);

            return response;
        }
    }
}